import { Container, Row, Col } from "react-bootstrap";
import { FaFacebook, FaInstagramSquare, FaYoutube } from "react-icons/fa";

const linkStyle = {
  color: "#d8f0f5",
  textDecoration: "none",
  display: "block",
  padding: "0.25rem 0",
};

const headingStyle = {
  color: "#fff",
  fontSize: "1.05rem",
  fontWeight: 700,
  marginBottom: "0.75rem",
};

const Footer = () => {
  const footerYear = new Date().getFullYear();
  return (
    <footer style={{ backgroundColor: "#0a5a6a", color: "#d8f0f5" }}>
      <Container style={{ padding: "3rem 1rem 1rem" }}>
        <Row>
          <Col md={4} className="mb-4">
            <h2 style={{ ...headingStyle, fontSize: "1.3rem" }}>
              zpotter gym software
            </h2>
            <p style={{ fontSize: "0.95rem" }}>
              zpotter is a complete gym management software for gyms, fitness
              studios and health clubs — memberships, fees, attendance, WhatsApp
              reminders and analytics in one place.
            </p>
            <div style={{ display: "flex", gap: "1rem", fontSize: "1.6rem" }}>
              <a
                href="https://www.facebook.com/profile.php?id=61560699947674"
                aria-label="zpotter on Facebook"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#d8f0f5" }}
              >
                <FaFacebook />
              </a>
              <a
                href="https://www.instagram.com/zpotter_technologies/?igsh=bGR2aWM0ZGdsZ283&utm_source=qr#"
                aria-label="zpotter on Instagram"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#d8f0f5" }}
              >
                <FaInstagramSquare />
              </a>
              <a
                href="https://www.youtube.com/@zpotter-gx8yw"
                aria-label="zpotter on YouTube"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#d8f0f5" }}
              >
                <FaYoutube />
              </a>
            </div>
          </Col>
          <Col md={4} sm={6} xs={6} className="mb-4">
            <h3 style={headingStyle}>Quick Links</h3>
            <a href="/#about" style={linkStyle}>
              About
            </a>
            <a href="/#features" style={linkStyle}>
              Features
            </a>
            <a href="/#pricing" style={linkStyle}>
              Pricing
            </a>
            <a href="/#contact" style={linkStyle}>
              Contact
            </a>
          </Col>
          <Col md={4} sm={6} xs={6} className="mb-4">
            <h3 style={headingStyle}>Legal</h3>
            <a href="/privacyPolicy" style={linkStyle}>
              Privacy Policy
            </a>
            <a href="/terms-and-conditions" style={linkStyle}>
              Terms and Conditions
            </a>
            <a href="/refundPolicy" style={linkStyle}>
              Refund Policy
            </a>
          </Col>
        </Row>
        <hr style={{ borderColor: "#1091ab" }} />
        <p
          className="text-center"
          style={{ fontSize: "0.9rem", paddingBottom: "0.5rem" }}
        >
          Powered by
        </p>
        <p
          className="text-center"
          style={{ fontSize: "0.9rem", paddingBottom: "0.5rem" }}
        >
          zpotter technologies &copy; {footerYear}. All rights reserved.
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
